import {LinkProp, ContentfulContent} from '../types';

interface RelatedArticleContent {
  content?: RelatedArticleEntry[];
}

export interface RelatedArticleEntry {
  content: RelatedArticleEntryContent[];
}

interface RelatedArticleEntryContent {
  nodeType: string;
  content: RelatedArticleEntryContentContent[];
  data: {
    uri: string;
  };
}

interface RelatedArticleEntryContentContent {
  value: string;
}

const getRelatedArticlesLinks = (data: Partial<ContentfulContent>): LinkProp[] => {
  const {content}: RelatedArticleContent = (data?.raw && JSON.parse(data.raw)) || {};
  if (!content) {
    return [];
  }
  const links: LinkProp[] = content.reduce((acc: LinkProp[], entry: RelatedArticleEntry) => {
    const hyperlink = entry.content.find((entryFind: RelatedArticleEntryContent) => entryFind.nodeType === 'hyperlink');
    if (hyperlink) {
      acc.push({
        label: hyperlink.content[0].value,
        href: hyperlink.data.uri,
      });
    }
    return acc;
  }, []);
  return links;
};

export default getRelatedArticlesLinks;
